export default __webpack_public_path__ + "static/media/adicionar-arquivos2-imagem.a7900911.svg";